import {_t, bugsnagClientNotify, PaginationManager } from '@bark/bark-core';

export default async function () {
    try {
        
        var monthNames = [_t('common:jan_full'), _t("common:feb_full"), _t("common:mar_full"), _t("common:apr_full"), _t("common:may_full"), _t("common:jun_full"), _t("common:jul_full"), _t("common:aug_full"), _t("common:sep_full"), _t("common:oct_full"), _t("common:nov_full"), _t("common:dec_full")];
        var topics = {
            'all': {
                topic_id: 'all',
                topic_name: 'All',
                primary_color_css_hex: '#111637',
                secondary_color_css_hex: '#F9F9FA'
            }
        };

        function insertHandlebarsTemplateContent(templateId, targetSelector, data) {
            var hb = Handlebars.compile($(templateId).html());
            $(targetSelector).html(hb(data));
        }

        function generateTopicsList(data) {
            var updatesData = data.data;
            for (var i = 0; i < updatesData.length; i++) {
                if (!topics.hasOwnProperty(updatesData[i]['id'])) {
                    topics[updatesData[i]['id']] = {
                        topic_id: updatesData[i]['id'],
                        topic_name: updatesData[i]['topic_name'],
                        primary_color_css_hex: updatesData[i]['primary_color_css_hex'],
                        secondary_color_css_hex: updatesData[i]['secondary_color_css_hex']
                    };
                }
            }
            topics = Object.values(topics).sort(function (a, b) {
                return a.topic_id === "all" ? -100 : a.topic_name < b.topic_name ? -1 : 1;
            });
            return topics;
        }

        function parseUpdateData(updatesData) {
            var updates = [];
            var unread_ids = [];
            for (var i = 0; i < updatesData.length; i++) {
                var publishArr = ("" + updatesData[i]['publish_date']).split(' ')[0].split('-');
                updates.push({
                    topic_id: updatesData[i]['topic_id'],
                    id: updatesData[i]['id'],
                    feature_image_url: updatesData[i]['feature_image_url'],
                    title: updatesData[i]['title'],
                    publish_date: publishArr[2] + " " + monthNames[parseInt(publishArr[1]) - 1] + " " + publishArr[0],
                    topic_name: updatesData[i]['topic_name'],
                    primary_color_css_hex: updatesData[i]['primary_color_css_hex'],
                    secondary_color_css_hex: updatesData[i]['secondary_color_css_hex'],
                    short_content: updatesData[i]['short_content'],
                    read_at: updatesData[i]['read_at'],
                    short_seen_at: updatesData[i]['short_seen_at'],
                    quick_seen_at: updatesData[i]['quick_seen_at'],
                });
                if (!updatesData[i]['short_seen_at']) {
                    unread_ids.push(updatesData[i]['id']);
                }
            }
            return {updates: updates, unread_ids: unread_ids};
        }

        function updateShortSeenStatus() {
            Bark.api('seller-comms/updates/read/',
                {
                    'read_type': 'short_seen'
                },
                function (data) {
                    $('.js-updates-count-header.red-circle').fadeOut();
                }, function (err) {
                    bugsnagClientNotify("Error posting updates as read", err);
                }
                , 'POST', Bark.apiVersionHeader('v2'));
        }

        function fetchAndParseUpdates(topic, limit, offset) {
            var payload = {};
            var is_filtered = false;
            if (topic && topic.topic_name !== 'All' && topic.topic_id > 0) {
                payload.topic_id = topic.topic_id;
                is_filtered = true;
            }
            if (limit && limit > 0) {
                payload.limit = limit;
            }
            if (offset && offset > 0) {
                is_filtered = true;
                payload.offset = offset;
            }

            Bark.api('seller-comms/updates/',
                payload,
                function (data) {
                    if (data.status) {
                        var updatesData = data.data;
                        var updatesParsed = parseUpdateData(updatesData.updates);
                        var unread_ids = updatesParsed.unread_ids;
                        var updates = updatesParsed.updates;
                        if (unread_ids.length > 0) {
                            updateShortSeenStatus();
                        }
                        if (updatesData.last_page < 2 && !is_filtered) {
                            $('.js-topic-selection').remove();
                        }
                        insertHandlebarsTemplateContent('#list-update-content', '#updates_page', {updates: updates});
                        new PaginationManager().output('.js-pagination', updatesData.last_page, updatesData.current_page, function (e) {
                            $('html, body').animate({
                                scrollTop: $('#updates_page').offset().top - 90
                            }, 1000);
                            insertHandlebarsTemplateContent('#waiting-loader-hb', '.js-updates-list', {});
                            fetchAndParseUpdates(topic, updatesData.per_page, (e - 1) * updatesData.per_page);
                        });
                    } else {
                        insertHandlebarsTemplateContent('#list-update-error', '#updates_page', {
                            "go_back_to_homepage_or_help_center": _t("seller_updates:list-update-content-section.go-back-to-homepage-or-help-center", {
                                "homepage_link": `<a href="${_l("/")}">${_t("seller_updates:list-update-content-section.homepage-link", {})}</a>`,
                                "help_centre_link": `<a href="${_l("https://help.bark.com/")}">${_t("seller_updates:list-update-content-section.help-centre-link", {})}</a>`
                            })
                        });
                    }
                }, function (err) {
                    insertHandlebarsTemplateContent('#list-update-error', '#updates_page', {
                        "go_back_to_homepage_or_help_center": _t("seller_updates:list-update-content-section.go-back-to-homepage-or-help-center", {
                            "homepage_link": `<a href="${_l("/")}">${_t("seller_updates:list-update-content-section.homepage-link", {})}</a>`,
                            "help_centre_link": `<a href="${_l("https://help.bark.com/")}">${_t("seller_updates:list-update-content-section.help-centre-link", {})}</a>`
                        })
                    });
                    bugsnagClientNotify("Error getting updates list", err);
                }, 'GET',
                Bark.apiVersionHeader('v2')
            );
        }

        function fetchTopics() {
            Bark.api('seller-comms/updates/topics',
                {},
                function (data) {
                    topics = generateTopicsList(data)
                    var selectedTopic = 'All';
                    if (topics.length > 2) {
                        insertHandlebarsTemplateContent('#topics-selection', '.js-topic-selection.d-sm-none', {
                            'topics': topics,
                            'selected_topic_name': selectedTopic,
                            'for_mobile': true
                        });
                        insertHandlebarsTemplateContent('#topics-selection', '.js-topic-selection.d-none', {
                            'topics': topics,
                            'selected_topic_name': selectedTopic,
                            'for_mobile': false
                        });
                    }
                },
                function (err) {
                    insertHandlebarsTemplateContent('#list-update-error', '#updates_page', {
                        "go_back_to_homepage_or_help_center": _t("seller_updates:list-update-content-section.go-back-to-homepage-or-help-center", {
                            "homepage_link": `<a href="${_l("/")}">${_t("seller_updates:list-update-content-section.homepage-link", {})}</a>`,
                            "help_centre_link": `<a href="${_l("https://help.bark.com/")}">${_t("seller_updates:list-update-content-section.help-centre-link", {})}</a>`
                        })
                    });
                    bugsnagClientNotify("Error fetching topics",  err);
                },
                'GET',
                Bark.apiVersionHeader('v2')
            )
        }

        fetchAndParseUpdates('All', 10, 0);
        fetchTopics();

        $('#updates_page').on('topic_changed', function (e) {
            $('.js-pagination').html('');
            insertHandlebarsTemplateContent('#waiting-loader-hb', '.js-updates-list', {});
            $('html, body').animate({
                scrollTop: 0
            }, 100);
            fetchAndParseUpdates(e.topic, 10, 0);
        });

    } catch (err) {
        bugsnagClientNotify('Error loading list seller update', err)
        console.log(err);
    }
}
